import axios from 'axios';

const staticContentAxios = axios.create({
  baseURL: `${process.env.REACT_APP_STATIC_CONTENT_URL}`,
});

const indexerAxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_REST_API}`,
});

export { staticContentAxios, indexerAxiosInstance };
